<script setup>
  import { ref, computed, onMounted, watchEffect, watch, onUnmounted } from 'vue';
  import { useSpotStore } from '@/stores/SpotStore';
  import { useProForecastStore } from '@/stores/ProForecastStore';
  import { useUserStore } from '@/stores/UserStore'
  import useLegacyBridge from "@/composables/useLegacyBridge";

  const content = defineModel('content');

  const props = defineProps({
    isNCWind: {
      type: Boolean,
      required: true
    },
    ncWindDataEnabled: {
      type: Boolean,
      required: false
    },
     useExternalDataBlock: {
      type: Boolean,
      default: false
    },
    zoom: {
      type: Number,
      required: false,
      default: 12
    },
    modelSelectorTarget: {
      type: HTMLElement,
      required: false
    },
    legendTarget: {
      type: HTMLElement,
      required: false
    },
    selectedModelIds: {
      type: [Array, String],
      required: false
    }
  });

  const spotStore = useSpotStore();
  const proForecastStore = useProForecastStore();
  const userStore = useUserStore();

  const { basicGraph } = useLegacyBridge();
  
  const graphContainer = ref(null);
  const modelSelectorContainer = ref(null);
  const ncWindDataEnabled = ref(props.ncWindDataEnabled || false);
  const loaded = ref(false);

  const showProForecastModel = computed(() => spotStore.proForecastIdIfExists && spotStore.hasSpotProduct(3) && proForecastStore.canShowProForecast);
  const proForecastModelId = computed(() => spotStore.proForecastIdIfExists);

  const getProForecastModel = async () => {
    let spotForecastModelData = null;

    if (userStore.memberLevel >= 49) {
      await proForecastStore.getProForecast(proForecastModelId.value);
      spotForecastModelData = proForecastStore.buildSpotForecastModelData(spotStore.spotId, spotStore.localUTCOffset);
    }

    if (!spotForecastModelData) {
      console.warn("No Pro Forecast Model Data available");
      return spotForecastModelData;
    }

    return {
      is_premium: true,
      is_pro_only: true,
      model_name: 'Pro Forecast',
      model_id: -9999,
      model_color: '513A85',
      model_data: spotForecastModelData,
      is_upgrade_available: userStore.memberLevel < 49,
    }
  };
  
  const loadGraph = async () => {
    const settings = {
      showModelData: true,
      showModelSelector: true,
      modelData: {...spotStore.forecastModelData},
      modelSelectorTarget: props.modelSelectorTarget ? props.modelSelectorTarget : modelSelectorContainer.value,
      legendTarget: props.legendTarget,
      spotId: spotStore.spotId,
      favSpotId: spotStore.spotFavoriteId,
      lat: spotStore.lat,
      lon: spotStore.lon,
      type: 'detail',
      zoom: props.zoom,
      isNCWind: props.isNCWind,
			ncWindDataEnabled: ncWindDataEnabled.value
    }

    if (props.selectedModelIds) {
      settings.selectedModelIds = props.selectedModelIds
    }

    if (showProForecastModel.value) {
      const proForecastModelData = await getProForecastModel();

      if (proForecastModelData) settings.additionalModels = [proForecastModelData];
    }
    
    content.value = basicGraph(graphContainer.value, settings);
    loaded.value = true;
  }

  watchEffect(() => ncWindDataEnabled.value = props.ncWindDataEnabled || false);

  onMounted(() => {   
    loadGraph();
  })  

  onUnmounted(() => {
    if (!props.legendTarget) return;

    const legend = props.legendTarget;
    legend.innerHTML = '';
  });
</script>

<template>
  <div
    class="jwx-data-container__main-content"
    style="width: 100%; height: 100%; background-color: #ffffff;"
    ref="graphContainer"
  ></div>
 
</template>